"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledFormSection = void 0;
const ui_components_1 = require("@groupby/ui-components");
const styled_components_1 = __importDefault(require("styled-components"));
exports.StyledFormSection = styled_components_1.default.div `
  display: flex;
  flex-direction: column;
  flex: 1;
  gap: ${({ theme }) => theme.spacing(1)};
  min-height: 0;

  .form-section-header {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    gap: 0.5rem;
  }

  .form-section-header--sticky {
    position: sticky;
    top: -1rem; // offsets StyledDialogContent padding-top
    z-index: 3;
    background-color: ${({ theme }) => theme.palette.common.white};
    padding: ${({ theme }) => theme.spacing(1)} 0;
  }

  .form-section-heading-content {
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    width: 10rem;
  }

  .form-section-attribute-name {
    overflow: hidden;
    color: ${ui_components_1.baseColors.primaryBlueDark500};
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.25rem;
    letter-spacing: 0;
    white-space: pre-wrap;
  }

  .form-section-subheading {
    color: ${ui_components_1.baseColors.primaryBlueDark500};
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.5rem;
    letter-spacing: 0;
  }

  .form-section-search {
    width: min(100%, 31.5rem);
  }

  .list-container {
    width: 100%;
    margin-bottom: ${({ theme }) => theme.spacing(1)};
    min-height: 0;
  }

  .list-container--constrained {
    flex: 1 1 auto;
    height: 100%;
    max-height: 100%;
    overflow: hidden;
  }

  .list-container--dynamic {
    flex: 0 0 auto;
  }

  .value-form-list-window--no-scroll {
    overflow-y: hidden !important;
  }

  .form-section-load-more-sentinel {
    min-height: 1px;
  }

  .value-form-list-search-skeleton {
    display: flex;
    flex-direction: column;
    flex: 1;
    gap: ${({ theme }) => theme.spacing(1)};
    min-height: 0;
    padding-top: ${({ theme }) => theme.spacing(1)};
  }

  .value-form-list-search-skeleton-row {
    display: flex;
    gap: ${({ theme }) => theme.spacing(1)};
    padding-left: 0.5rem;

    .MuiSkeleton-root {
      flex-shrink: 0;
      transform: none;
    }

    .MuiSkeleton-root:last-child {
      flex: 1 1 auto;
      min-width: 0;
    }
  }

  .value-form-list-divider-row {
    align-items: center;
    display: flex;
    padding: 0 ${({ theme }) => theme.spacing(1)};
  }

  .value-form-list-divider {
    width: 100%;
  }

  .value-form-list-section-label-row {
    display: flex;
    align-items: center;
    height: 100%;
  }

  .value-form-list-section-label {
    flex: 0 0 10rem;
    width: 10rem;
    min-width: 10rem;
    overflow: hidden;
    color: ${({ theme }) => theme.palette.common.black};
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 1rem;
    letter-spacing: 0;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .load-more-indicator {
    padding: ${({ theme }) => theme.spacing(1)};
  }

  .action-add {
    align-self: auto;

    &.MuiButton-root {
      min-width: 0;
    }

    svg path {
      fill: currentColor;
    }
  }

  .attribute-form-item-divider {
    border-color: ${({ theme }) => theme.palette.grey[200]};
    margin: 1.5rem 0;
    width: 100%;
  }

  && .MuiAlert-root {
    box-shadow: none;
    color: ${({ theme }) => theme.palette.accent.main};

    svg path {
      fill: ${ui_components_1.baseColors.orange300};
    }
  }
`;
